import { render } from "./TransportCostApproveList.vue?vue&type=template&id=6c4ac46a&scoped=true&ts=true"
import script from "./TransportCostApproveList.vue?vue&type=script&lang=ts"
export * from "./TransportCostApproveList.vue?vue&type=script&lang=ts"

import "./TransportCostApproveList.vue?vue&type=style&index=0&id=6c4ac46a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-sakakibara\\Documents\\Git\\workflow-system\\workflow\\frontend\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4ac46a"]])

export default __exports__